import { Injectable } from "@angular/core";
import {
	BehaviorSubject,
	Observable,
	Subject,
	catchError,
	map,
	retry,
} from "rxjs";

//models
import { environment } from "src/environments/environment";
import { CebeProcedureViewModel } from "../models/centros/cebe-procedure.model";
import { CebeViewModel } from "../models/centros/cebe.model";

//services
import { NotificacionCese } from "../models/centros/NotificacionCese.model";
import { ApiEnum, HttpDataService } from "./http-data.service";

@Injectable({
	providedIn: "root",
})
export class CebesService {
	constructor(private readonly httpDataService: HttpDataService) {}

	private readonly cebeId = new BehaviorSubject<number>(0);

	private readonly cebeActividadValueChanged = new Subject<void>();
	cebeActividadValueChanged$ = this.cebeActividadValueChanged.asObservable();

	private readonly cebeTipoProyectoValueChanged = new Subject<void>();
	cebeTipoProyectoValueChanged$ =
		this.cebeTipoProyectoValueChanged.asObservable();

	private tipoProyectoIDValue: any;

	setTipoProyectoIDValue(value: any) {
		this.tipoProyectoIDValue = value;
	}

	getTipoProyectoIDValue(): any {
		return this.tipoProyectoIDValue;
	}

	private actividadIDValue: any;

	setActividadIDValue(value: any) {
		this.actividadIDValue = value;
	}

	getActividadIDValue(): any {
		return this.actividadIDValue;
	}

	setCebeId(id: number): void {
		this.cebeId.next(id);
	}

	getCebeId(): Observable<number> {
		return this.cebeId.asObservable();
	}

	getCebes(): Observable<CebeProcedureViewModel[]> {
		return this.httpDataService
			.get$<
				CebeProcedureViewModel[]
			>(ApiEnum.API_ROOT, environment.endpoint.contratos.getContratosPadreList)
			.pipe(
				map((cebes) => {
					return cebes;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebeProcedureViewModel[]>(
						"getCebes",
					),
				),
			);
	}

	getCebeById(cebeId: number) {
		return this.httpDataService
			.get$<CebeViewModel>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.centros.getCentroByCebes}/${cebeId}`,
			)
			.pipe(
				map((cebe) => {
					return cebe;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebeViewModel>(
						"getCebeById",
					),
				),
			);
	}

	updateCebe(cebe: CebeViewModel) {
		return this.httpDataService
			.put$<CebeViewModel>(
				ApiEnum.API_ROOT,
				environment.endpoint.contratos.updateContrato,
				cebe,
			)
			.pipe(
				map((cebe) => {
					return cebe;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebeViewModel>(
						"updateCebe",
					),
				),
			);
	}

	triggerCebeActividadValueChanged() {
		this.cebeActividadValueChanged.next();
	}

	triggerCebeTipoProyectoValueChanged() {
		this.cebeTipoProyectoValueChanged.next();
	}

	NotificarCese(id: number) {
		return this.httpDataService
			.post$<Boolean>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.contratos.notificacionCese}/${id}`,
				id,
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<Boolean>(
						"notificacionCese",
					),
				),
			);
	}

	NotificarAlta(id: number) {
		return this.httpDataService
			.post$<Boolean>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.contratos.notificacionAlta}/${id}`,
				id,
			)
			.pipe(
				map((centro) => {
					return centro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<Boolean>(
						"notificacionCese",
					),
				),
			);
	}

	getNotificacionCese(id: number) {
		return this.httpDataService
			.get$<NotificacionCese>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.contratos.notificacionCese}/${id}`,
			)
			.pipe(
				map((cebe) => {
					return cebe;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<NotificacionCese>(
						"getNotificacionCese",
					),
				),
			);
	}

	getNotificacionAlta(id: number) {
		return this.httpDataService
			.get$<NotificacionCese>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.contratos.notificacionAlta}/${id}`,
			)
			.pipe(
				map((cebe) => {
					return cebe;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<NotificacionCese>(
						"getNotificacionCese",
					),
				),
			);
	}
}
